import { render, staticRenderFns } from "./Allowance.vue?vue&type=template&id=94333ee0"
import script from "./Allowance.vue?vue&type=script&lang=js"
export * from "./Allowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports